import ddt from '@wix/da-ddt';
import { all, call, put, race, select, take, takeLatest } from 'redux-saga/effects';
import { actions as modalActions } from '../../Modals';
import { getIsLoggedIn, getIsVerificationNeeded } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { actions as userActions } from '../../redux/users';
import { pushVerificationPopup } from '../../VerificationPopup/actions';
import { showReportModal, unblockDeviationAuthor, hideDeviation, unhideDeviation, unhideDeviationFail, unhideDeviationSuccess, blockDeviationAuthor, hideDeviationFail, hideDeviationSuccess } from './actions';
import { ModalType } from '../../Modals/redux/types';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { ReferralType } from '@wix/da-bi/pkg/constants';
const logger = ddt.createLogger('moderation');
// TODO: all changes to blocked state should be reflected in entities
// however we can't rely fully on that as there are places without
// normalization. So also need to update browse etc. to normalize
// For now, all this is blissfully ignored here, so devpage will
// reflect the changes but parent not
function* doUnhideDeviation(deviationid) {
    const data = {
        deviationid
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'unhide',
        data
    }, ()=>({
            success: true
        }), 'dadeviation');
    return result && !isApiError(result);
}
function* doHideDeviation(deviationid) {
    const data = {
        deviationid
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'hide',
        data
    }, ()=>({
            success: true
        }), 'dadeviation');
    return result && !isApiError(result);
}
function* handleHideDeviation({ payload: deviationId }) {
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.REPORT
        }));
        return;
    }
    const success = yield call(doHideDeviation, deviationId);
    if (!success) {
        yield put(hideDeviationFail(deviationId));
        return;
    }
    yield put(hideDeviationSuccess(deviationId));
}
function* handleUnhideDeviation({ payload: deviationId }) {
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.REPORT
        }));
        return;
    }
    const success = yield call(doUnhideDeviation, deviationId);
    if (!success) {
        yield put(unhideDeviationFail(deviationId));
        return;
    }
    yield put(unhideDeviationSuccess(deviationId));
}
function* handleUnblockDeviant({ payload: { userId, deviationId } }) {
    if (!userId) {
        logger.warn('Attempted unblock deviant without userId');
        return;
    }
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.REPORT
        }));
        return;
    }
    // here we kick off the shared unblock process
    yield put(userActions.unblockUser(userId));
    // and now we wait for either result
    const { fail } = yield race({
        success: take((resultAction)=>resultAction.type === userActions.unblockUserSuccess.toString() && resultAction.payload === userId),
        fail: take((resultAction)=>resultAction.type === userActions.unblockUserFail.toString() && resultAction.payload === userId)
    });
    if (fail) {
        // if unblocking failed, nothing to do here, life sucks
        return;
    }
    // and so, we succeeded unblocking the user, now to unhide the originating deviation
    yield call(handleUnhideDeviation, unhideDeviation(deviationId));
}
function* handleBlockDeviant({ payload: { user } }) {
    yield put(modalActions.pushModal(ModalType.USER_BLOCK, {
        params: {
            user
        }
    }));
}
function* handleShowReportModal({ payload: { deviation } }) {
    const { isLoggedIn } = yield select((state)=>({
            isLoggedIn: getIsLoggedIn(state),
            isVerificationNeeded: getIsVerificationNeeded(state)
        }));
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.REPORT
        }));
        return;
    }
    if (!getIsVerificationNeeded) {
        yield put(pushVerificationPopup('report'));
        return;
    }
    const { deviationId } = deviation;
    yield put(modalActions.pushModal(ModalType.REPORT_DEVIATION_MODAL, {
        params: {
            deviationId
        }
    }));
}
export default function* moderationRootSaga() {
    yield all([
        takeLatest(showReportModal, handleShowReportModal),
        takeLatest(hideDeviation, handleHideDeviation),
        takeLatest(unhideDeviation, handleUnhideDeviation),
        takeLatest(unblockDeviationAuthor, handleUnblockDeviant),
        takeLatest(blockDeviationAuthor, handleBlockDeviant)
    ]);
}

//# sourceMappingURL=saga.js.map